import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '@ryanar/react-auth-provider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import routePaths from 'routes/routePaths';
import { ContactUsModal } from 'components/modals';
import Topic from './Topic';
import topics from './topics';

import styles from './FAQs.module.css';

const renderTopics = () =>
  topics.map(({ question, answers }) => (
    <Topic key={question} title={question}>
      <List component="div" className={styles.questionsList}>
        {answers.map(({ answer }) => (
          <ListItem key={answer} disableGutters>
            <article>
              <p className={styles.answer}>{answer}</p>
            </article>
          </ListItem>
        ))}
      </List>
    </Topic>
  ));

const FAQs = () => {
  const { authenticated } = React.useContext(AuthContext);

  const history = useHistory();
  const goBack = () => history.goBack();

  const [isContactsModalOpen, setContactsModalOpen] = useState(false);
  const closeContactsModal = () => setContactsModalOpen(false);

  const openContactUs = () => {
    if (authenticated) {
      history.push(routePaths.contactUs);
    } else {
      setContactsModalOpen(true);
    }
  };

  return (
    <DashboardCard className={!authenticated ? styles.container : undefined}>
      <ContactUsModal open={isContactsModalOpen} onClose={closeContactsModal} />
      <NavigationTitle
        to="/faq"
        onClick={goBack}
        layoutType={authenticated ? LayoutType.dashboard : LayoutType.support}
      >
        Frequently Asked Questions
      </NavigationTitle>
      <div className={styles.gridContainer}>
        <div className={styles.topicsArea}>
          <List component="nav" className={styles.topicsList} disablePadding>
            {renderTopics()}
          </List>
        </div>
        <div className={styles.contactArea}>
          <p className={styles.linkDescription}>Didn’t find an answer to your question?</p>
          <Button className={styles.contactButton} onClick={openContactUs}>
            Contact Us
          </Button>
        </div>
      </div>
    </DashboardCard>
  );
};

export default FAQs;
